// فعالیت‌های بودجه
// خود فرم پروژه/فعالیت مشترک است (یک جدول با ستون IsProject)، اینجا فقط با فیلتر فعالیت بازش می‌کنیم
import React from 'react';
import AccountingProject from '../Accounting/AccountingProject';

export default function BudgetActivity({ user, onBack }) {
  return <AccountingProject user={user} onBack={onBack} initialType="activity" />;
}
